/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  useHistory, useLocation,
} from 'react-router-dom';
import {
  setCidade, setAuthToken, getTotem,
} from '../../api/apiFactory';
import {
  fetchCidades, fetchConfiguracoes, fetchLimparCookie,
  fetchNomeCidade, fetchVerificarStatusCidade,
} from '../../api/endpoints';
import {
  definirCidade, fetchConfiguracoesCidade, selectCidade, desfazerCidade,
} from '../../app/slices/cidadesSlice';
import { desfazerConexao, selectLogin } from '../../app/slices/loginSlice';
import {
  abrirModalLoginManifestacao,
  resetarModais, selectModal,
} from '../../app/slices/modalSlice';
import { definirSecretaria, desfazerSecretaria } from '../../app/slices/secretariasSlice';
import AppHeader from '../../components/AppHeader/AppHeader';
import Botao from '../../components/Botao/Botao';
import Carregar from '../../components/Carregar/Carregar';
import GridBotao from '../../components/GridBotao/GridBotao';
import ModalAjuda from '../../components/ModalAjuda/ModalAjuda';
import ModalBairro from '../../components/ModalBairro/ModalBairro';
import ModalContato from '../../components/ModalContato/ModalContato';
import ModalEnquete from '../../components/ModalEnquete/ModalEnquete';
import ModalEscolhaLoginTotem from '../../components/ModalEscolhaLoginTotem/ModalEscolhaLoginTotem';
import ModalLogin from '../../components/ModalLogin/ModalLogin?v=2023-04-19T16:50:00';
import ModalLoginTotem from '../../components/ModalLoginTotem/ModalLoginTotem';
import ModalProtocolo from '../../components/ModalProtocolo/ModalProtocolo';
import {
  Alerta, AppBody, AppFragment, CampoForm,
  Container, Divisor, Grid, GridInicial, Linha, Titulo,
} from '../../styles/base';
import { espacamento } from '../../styles/constants/sizes';
import { replaceDiacritico } from '../../util/stringFactory';
import { isCorClara } from '../../util/color';

const defaulValues = {
  BuscaCidade: '',
  IdEstado: '',
  NomeEstado: '',
};

const SelecionarCidade = () => {
  const [listaEstados, setListaEstados] = useState(null);
  const [listaCidades, setListaCidades] = useState(null);
  const [estadoSelecionado, setEstadoSelecionado] = useState(false);
  // const [listaSecretarias, setListaSecretarias] = useState(null);
  const [values, setValues] = useState(defaulValues);
  const { search } = useLocation();

  const [pesquisa, setPesquisa] = useState('');
  const [texto, setTexto] = useState('');

  const dispatch = useDispatch();

  const history = useHistory();

  const dadosCidade = useSelector(selectCidade);
  const dadosLogin = useSelector(selectLogin);

  // Essa propriedade foi criada para evitar um efeito visual que estava acontecendo: Quando eu ficava trocando entre cidades, a depender da quantidade de botões (ouvidoria, sic e zeladoria),
  // a animação de troca dos botões ficava "sambando" quando ia de uma cidade que tinha 3 botões para uma com duas, e vice versa. Isso ocorre porque o "dadosCidade" demora um pouco para ser renderizado, e nesse meio tempo ocorre a "dança" dos botões.
  // Para corrigir isso então, crio o objeto abaixo, o qual receberá o conteúdo advindo da requisição "fetchConfiguracoes", e daí irei utiliza-lo, assim não ocorrerá a dança dos botões.
  // Inclusive, esse mesmo método é usado para limpar o "cache" de configuração de uma cidade para outra, pois também sem ele, estava ocorrendo de caso eu logasse em uma cidade que só tem ouvidoria, e portanto tem que abrir diretamente o módulo, e dai eu troco pra uma outra cidade
  // a qual NÃO tem só ouvidoria, e portanto deveria exibir a página inicial, ainda sim estava redirecionando para a pag de ouvidoria, pois estava ocorrendo um "cache" das configurações da cidade anterior.
  const [dadosCidadeLoading, setDadosCidadeLoading] = useState(null);

  // Essa propriedade, assim como a cima, também é pra controlar o efeito de loading conforme carrega os botões da cidade, mas além disso, essa propriedade está sendo usada como PROTEÇÃO para quando
  // o usuário estiver entrando na página pela primeira vez, pois sem esta, a tela ficaria em loading infinito, visto que "setDadosCidade" seria null e portanto ficaria em loading. Portanto tempos essa propriedade para evitar isso.
  const [carregando, setCarregando] = useState(false);

  // Bloco comentado pois agora a tela padrão das secretarias de ouvidoria (e formulario de manifestação) não abrem aqui na url inicial (/). A ouvidoria abrirá em "/ouvidoria"
  // const dadosSecretaria = useSelector(selectSecretaria);

  const dadosModal = useSelector(selectModal);

  const cookie = document.cookie ? document.cookie : null;
  const cookieSeparado = cookie ? cookie.split('&') : null;
  const cookieSelecionado = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('Id2')) : null;
  const cookieSelecionadoSeparado = cookieSelecionado ? cookieSelecionado.split('=') : null;
  const cookieId = cookieSelecionadoSeparado
    ? cookieSelecionadoSeparado[cookieSelecionadoSeparado.length - 1]
    : null;

  const cookieSelecionado2 = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('IdeCrie')) : null;
  const cookieSelecionadoSeparado2 = cookieSelecionado2 ? cookieSelecionado2.split('=') : null;
  const cookieIdEcrie = cookieSelecionadoSeparado2
    ? cookieSelecionadoSeparado2[cookieSelecionadoSeparado2.length - 1]
    : null;

  const cookieSelecionado3 = cookieSeparado ? cookieSeparado.find((elemento) => elemento.startsWith('IdeSipe')) : null;
  const cookieSelecionadoSeparado3 = cookieSelecionado3 ? cookieSelecionado3.split('=') : null;
  const cookieIdEsipe = cookieSelecionadoSeparado3
    ? cookieSelecionadoSeparado3[cookieSelecionadoSeparado3.length - 1]
    : null;

  window.onload = () => {
    dispatch(resetarModais());
  };

  const limpaLoginAnonimo = (data) => {
    if (data && data.data && data.data.anonimo === 'anonimo') {
      setAuthToken(null);
      dispatch(desfazerConexao());
    }
  };

  const checaCidadeAtiva = (id) => {
    if (getTotem() !== 'true' && id) {
      fetchVerificarStatusCidade(id).then((response) => {
        if (response === 'N') {
          dispatch(desfazerConexao());
          dispatch(desfazerCidade());
          dispatch(desfazerSecretaria());
          limpaLoginAnonimo(dadosLogin);
          history.push('/');
        }
      });
    } else {
      history.push('/');
    }
  };

  const carregarRedirecionamento = async () => {
    setCarregando(true);

    fetchConfiguracoes().then((response) => {
      setDadosCidadeLoading(response);

      if (response.TelaIntrodutoria && response.TelaIntrodutoria === 'N') {
        history.push('/ouvidoria');
      } else {
        setCarregando(false);
      }
    });
  };

  const escolherCidade = async (Id, IdeCrie, IdeSipe, Campo, Brasao) => {
    setDadosCidadeLoading(null);
    checaCidadeAtiva(Id);
    // Bloco comentado pois agora a tela padrão das secretarias de ouvidoria (e formulario de manifestação) não abrem aqui na url inicial (/). A ouvidoria abrirá em "/ouvidoria"
    // setListaSecretarias(null);
    setCidade({
      Id, IdeCrie, IdeSipe, Campo,
    });

    await carregarRedirecionamento();

    setEstadoSelecionado(false);
    setValues(defaulValues);
    dispatch(definirCidade({
      idCidade: Id,
      idCidadeEcrie: IdeCrie,
      idCidadeEsipe: IdeSipe,
      nomeCidade: Campo,
      brasaoCidade: Brasao,
    }));
    await fetchLimparCookie();
    await dispatch(fetchConfiguracoesCidade());
    // Bloco comentado pois agora a tela padrão das secretarias de ouvidoria (e formulario de manifestação) não abrem aqui na url inicial (/). A ouvidoria abrirá em "/ouvidoria"
    // await fetchSecretarias().then(setListaSecretarias);
  };

  const greetings = () => {
    const hora = new Date().getHours();
    if (hora >= 0 && hora < 12) return 'Bom dia';
    if (hora >= 12 && hora < 18) return 'Boa tarde';
    return 'Boa noite';
  };

  useEffect(() => {
    fetchCidades().then(setListaEstados);

    if (getTotem() === 'true') {
      // setTimeout(() => {
      //   document.querySelector('body').click();
      //   document.querySelector('body').focus();
      //   document.querySelector('body').click();
      // }, 2000);

      history.push('/totem');
    }

    if (search && search.includes('&id=')) {
      const idCidade = search.split('&id=')[1];
      dispatch(desfazerConexao());
      dispatch(desfazerCidade());
      dispatch(desfazerSecretaria());
      limpaLoginAnonimo(dadosLogin);
      fetchNomeCidade(idCidade).then((nomeCidade) => { escolherCidade(idCidade, 0, 0, nomeCidade); });
    }

    if (cookieId) {
      dispatch(desfazerConexao());
      dispatch(desfazerCidade());
      dispatch(desfazerSecretaria());
      limpaLoginAnonimo(dadosLogin);
      fetchNomeCidade(cookieId).then((nomeCidade) => { escolherCidade(cookieId, cookieIdEcrie, cookieIdEsipe, nomeCidade); });
    }
    // Bloco comentado pois agora a tela padrão das secretarias de ouvidoria (e formulario de manifestação) não abrem aqui na url inicial (/). A ouvidoria abrirá em "/ouvidoria"
    // if (dadosCidade.data) {
    //   fetchSecretarias().then(setListaSecretarias);
    // }
    if (getTotem() !== 'true') checaCidadeAtiva(dadosCidade && dadosCidade.data && dadosCidade.data.idCidade);

    if (dadosCidade.data) carregarRedirecionamento();
  }, []);

  useEffect(() => {
    setValues({
      ...values,
      BuscaCidade: pesquisa,
    });
  }, [pesquisa]);

  // Método adicionado somente para abrir, a partir da tela inicial, a secretaria de passe livre de Juiz de Fora
  const selecionarSecretaria = (Id, Campo, CorHtml) => {
    // Passe Livre Estudantil em Juiz de Fora. Não permitindo com que o usuário entre no cadastro do formulário estando "Logado" como anônimo. Irá abrir o modal de cadastro/login.
    if (!dadosLogin.data || dadosLogin.data.anonimo === 'anonimo') {
      return dispatch(abrirModalLoginManifestacao({
        idSecretaria: Id,
        nomeSecretaria: Campo,
        corSecretaria: CorHtml,
        redirect: true,
      }));
    }

    // Se o usuário já estiver logado, iremos apenas definir a secretaria como "Passe Livre Estudantil". E no código do botão clicado, redirecionamos já para /ouvidoria
    return dispatch(definirSecretaria({
      idSecretaria: Id,
      nomeSecretaria: Campo,
      corSecretaria: CorHtml,
    }));
  };

  // Bloco comentado pois agora a tela padrão das secretarias de ouvidoria (e formulario de manifestação) não abrem aqui na url inicial (/). A ouvidoria abrirá em "/ouvidoria"
  // const selecionarSecretaria = (Id, Campo, CorHtml) => {
  //   checaCidadeAtiva(dadosCidade && dadosCidade.data && dadosCidade.data.idCidade);
  //   if (!dadosLogin.data && getTotem() !== 'true') {
  //     return dispatch(abrirModalLoginManifestacao({
  //       idSecretaria: Id,
  //       nomeSecretaria: Campo,
  //       corSecretaria: CorHtml,
  //     }));
  //   }

  //   if (!dadosLogin.data && getTotem() === 'true') {
  //     return dispatch(abrirModalTotemEscolhaLoginManifestacao({
  //       idSecretaria: Id,
  //       nomeSecretaria: Campo,
  //       corSecretaria: CorHtml,
  //     }));
  //   }

  //   if (dadosLogin.data.anonimo === 'naoanonimo') {
  //     return dispatch(definirSecretaria({
  //       idSecretaria: Id,
  //       nomeSecretaria: Campo,
  //       corSecretaria: CorHtml,
  //     }));
  //   }

  //   if (dadosCidade.configuracoes.OcultarAnonimoOuvidoria === 'N') {
  //     return dispatch(abrirModalLoginManifestacao({
  //       idSecretaria: Id,
  //       nomeSecretaria: Campo,
  //       corSecretaria: CorHtml,
  //     }));
  //   }

  //   return dispatch(definirSecretaria({
  //     idSecretaria: Id,
  //     nomeSecretaria: Campo,
  //     corSecretaria: CorHtml,
  //   }));
  // };

  if (!listaEstados) {
    return (
      <Carregar />
    );
  }

  if (dadosCidade.data && !dadosCidadeLoading && carregando) {
    return (
      <Carregar />
    );
  }

  // Bloco comentado pois agora a tela padrão das secretarias de ouvidoria (e formulario de manifestação) não abrem aqui na url inicial (/). A ouvidoria abrirá em "/ouvidoria"
  // if (dadosCidade.data && !listaSecretarias) {
  //   return (
  //     <Carregar />
  //   );
  // }

  // Bloco comentado pois agora a tela padrão das secretarias de ouvidoria (e formulario de manifestação) não abrem aqui na url inicial (/). A ouvidoria abrirá em "/ouvidoria"
  // if (dadosCidade.data && dadosSecretaria.data) {
  //   return (
  //     <AppFragment
  //       onKeyDown={(e) => {
  //         if (e.key === 'Escape') {
  //           dispatch(resetarModais());
  //         }
  //       }}
  //       tabIndex="0"
  //     >
  //       {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
  //       {dadosModal.modalLoginTotem === 'aberto' && (<ModalLoginTotem />)}
  //       {dadosModal.modalEscolhaLoginTotem === 'aberto' && (<ModalEscolhaLoginTotem />)}
  //       {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
  //       {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
  //       {dadosModal.modalArquivo === 'aberto' && (<VisualizadorArquivos />)}
  //       {dadosModal.modalBairro === 'aberto' && (<ModalBairro />)}
  //       {dadosModal.modalAssunto === 'aberto' && (<ModalAssunto />)}
  //       {dadosModal.modalCategoria === 'aberto' && (<ModalCategoria />)}
  //       {dadosModal.modalUnidade === 'aberto' && (<ModalUnidade />)}
  //       {dadosModal.modalProtocolo === 'aberto' && (<ModalProtocolo />)}
  //       {dadosModal.modalAnonimo === 'aberto' && (<ModalAnonimo />)}
  //       <AppHeader />
  //       <AppBody className="controle-fundo" totem={getTotem() === 'true'} desfoque={dadosModal.desfoque}>
  //         <FormularioManifestacao />
  //       </AppBody>
  //     </AppFragment>
  //   );
  // }

  // Bloco comentado pois agora a tela padrão das secretarias de ouvidoria (e formulario de manifestação) não abrem aqui na url inicial (/). A ouvidoria abrirá em "/ouvidoria"
  // if (dadosCidade.data && listaSecretarias.Message) {
  //   return (
  //     <AppFragment
  //       onKeyDown={(e) => {
  //         if (e.key === 'Escape') {
  //           dispatch(resetarModais());
  //         }
  //       }}
  //       tabIndex="0"
  //     >
  //       {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
  //       {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
  //       {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
  //       {dadosModal.modalProtocolo === 'aberto' && (<ModalProtocolo />)}
  //       <AppHeader />
  //       <AppBody className="controle-fundo" totem={getTotem() === 'true'} desfoque={dadosModal.desfoque}>
  //         <Container totem={getTotem() === 'true'}>
  //           <p>Não há nenhuma secretaria disponível.</p>
  //         </Container>
  //       </AppBody>
  //     </AppFragment>
  //   );
  // }

  if (dadosCidade.data && dadosCidadeLoading) {
    return (
      <AppFragment
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            dispatch(resetarModais());
          }
        }}
        tabIndex="0"
      >
        {dadosModal.modalLogin === 'aberto' && (<ModalLogin />)}
        {dadosModal.modalLoginTotem === 'aberto' && (<ModalLoginTotem />)}
        {dadosModal.modalEnquete === 'aberto' && (<ModalEnquete />)}
        {dadosModal.modalContato === 'aberto' && (<ModalContato />)}
        {dadosModal.modalAjuda === 'aberto' && (<ModalAjuda />)}
        {dadosModal.modalBairro === 'aberto' && (<ModalBairro />)}
        {dadosModal.modalProtocolo === 'aberto' && (<ModalProtocolo />)}
        {dadosModal.modalEscolhaLoginTotem === 'aberto' && (<ModalEscolhaLoginTotem />)}
        <AppHeader />
        {/* Bloco comentado pois agora a tela padrão das secretarias de ouvidoria (e formulario de manifestação) não abrem aqui na url inicial (/). A ouvidoria abrirá em "/ouvidoria" */}
        {/* {(dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.WhatsApp) && (getTotem() !== 'true') && (
          <a href={`https://wa.me/55${dadosCidade.configuracoes.WhatsApp.replace(' ', '').replace('-', '').replace('(', '').replace(')', '')}`} target="_blank" rel="noreferrer">
            <Botao whats2 />
          </a>
        )}
        {(getTotem() !== 'true') && (
          <>
            <Botao
              onClick={() => dispatch(abrirModalAjuda())}
              ajuda
            />
            <Botao
              onClick={() => dispatch(abrirModalAjuda())}
              topo
            />
          </>
        )}
        {(listaSecretarias.length > 15 && getTotem() === 'true') && (
          <>
            <Botao
              onClick={() => document.getElementById('totemSecretarias').scrollBy({
                top: -350,
                left: 0,
                behavior: 'smooth',
              })}
              totemUp
            />
            <Botao
              onClick={() => document.getElementById('totemSecretarias').scrollBy({
                top: 350,
                left: 0,
                behavior: 'smooth',
              })}
              totemDown
            />
          </>
        )} */}
        <AppBody className="controle-fundo" id="totemSecretarias" totem={getTotem() === 'true'} desfoque={dadosModal.desfoque}>
          <Container totem={getTotem() === 'true'}>
            {/* Bloco comentado pois agora a tela padrão das secretarias de ouvidoria (e formulario de manifestação) não abrem aqui na url inicial (/). A ouvidoria abrirá em "/ouvidoria" */}
            {/* <Titulo totem={getTotem() === 'true'}>Ouvidoria - Cadastro de manifestação</Titulo>

            {dadosCidade.configuracoes.TituloAjudaOuvidoria && (
              <>
                <TituloAjuda>
                  <div dangerouslySetInnerHTML={{ __html: dadosCidade.configuracoes.TituloAjudaOuvidoria }} />
                </TituloAjuda>

                <Divisor size="pequeno" />
              </>
            )}

            <Grid totem={getTotem() === 'true'}>
              {listaSecretarias.map(({
                Campo, Id, Icone, CorHtml,
              }) => (
                // Se o ícone for da cidade cincatarina, eu fixo um SVG, largura, altura, e cor diferentes
                (Icone === 'cincatarina' ? (
                  <GridBotao
                    onClick={() => selecionarSecretaria(Id, Campo, CorHtml)}
                    key={Id}
                    label={Campo}
                    title={Campo}
                    img="https://eouve.com.br/svg_icons/dark/cincatarina1.svg"
                    size={14}
                    imgWidth={120}
                    imgHeight={60}
                    cor="#ffffff"
                    secretaria
                    className="controle-secretaria"
                  />
                ) : (
                  <GridBotao
                    onClick={() => selecionarSecretaria(Id, Campo, CorHtml)}
                    key={Id}
                    label={Campo}
                    title={Campo}
                    img={`https://eouve.com.br/svg_icons/${isCorClara(CorHtml) ? 'dark' : 'light'}/${Icone}.svg`}
                    size={14}
                    imgWidth={50}
                    imgHeight={50}
                    cor={CorHtml}
                    secretaria
                    className="controle-secretaria"
                  />
                ))
              ))}
            </Grid>
            */}

            <Titulo totem={getTotem() === 'true'}>
              <span style={{ fontWeight: 'bold' }}>{greetings()}</span>
              , qual serviço você deseja escolher?
            </Titulo>
            <GridInicial totem={getTotem() === 'true'}>
              {/* Em Juiz de fora, adicionei estaticamente um botão que abre diretamente o cadastro de "manifestação" na secretaria de "Passe Livre Estudantil" (ID: 10534)

                Regras:
                1. Se não estiver logado, abrirá o modal de login para cadastrar ou logar.
                2. Se por algum motivo já tiver logado, no método selecionarSecretaria iremos definir a mesma, e abaixo no "to={...}" redirecionaremos para a página de cadastro de manifestação com a sec. já definida.
              */}
              {dadosCidadeLoading && dadosCidadeLoading.Cidade === 'Juiz de Fora' && (
                <GridBotao
                  to={!dadosLogin.data || dadosLogin.data.anonimo === 'anonimo' ? '/' : '/ouvidoria'}
                  onClick={() => { selecionarSecretaria('10534', 'Passe Livre Estudantil', 'rgb(25, 204, 178)'); }}
                  key="Passe Livre Estudantil"
                  label="Passe Livre Estudantil"
                  img="https://eouve.com.br/svg_icons/dark/directions_bus.svg"
                  size={17}
                  sizeDescricao={14}
                  imgWidth={55}
                  imgHeight={55}
                  cor="#19ccb2"
                  className="controle-secretaria"
                  descricao="Disponibilizado para os estudantes, clique aqui para solicitar o seu passe livre estudantil."
                  inicial
                />
              )}
              {dadosCidadeLoading.CartaDeServicos && dadosCidadeLoading.CorBotaoCartaServicos && (
                <GridBotao
                  to="/cartadeservicos"
                  onClick={() => { dispatch(desfazerSecretaria()); limpaLoginAnonimo(dadosLogin); }}
                  key="Carta de Serviços"
                  label="Carta de Serviços"
                  img={`https://eouve.com.br/svg_icons/${isCorClara(dadosCidadeLoading.CorBotaoCartaServicos) ? 'dark' : 'light'}/cartaservicos.svg`}
                  size={17}
                  sizeDescricao={14}
                  imgWidth={55}
                  imgHeight={55}
                  cor={dadosCidadeLoading.CorBotaoCartaServicos}
                  className="controle-secretaria"
                  descricao="Gostaria de conhecer quais serviços são oferecidos? Acesse aqui e saiba mais sobre como podemos atender suas necessidades."
                  inicial
                />
              )}
              {dadosCidadeLoading.CorBotaoOuvidoria && (
                <GridBotao
                  to="/ouvidoria"
                  onClick={() => { dispatch(desfazerSecretaria()); limpaLoginAnonimo(dadosLogin); }}
                  key="Ouvidoria"
                  label="Ouvidoria"
                  img={`https://eouve.com.br/svg_icons/${isCorClara(dadosCidadeLoading.CorBotaoOuvidoria) ? 'dark' : 'light'}/ouvidoria.svg`}
                  size={17}
                  sizeDescricao={14}
                  imgWidth={55}
                  imgHeight={55}
                  cor={dadosCidadeLoading.CorBotaoOuvidoria}
                  className="controle-secretaria"
                  descricao="Precisa enviar uma Reclamação, Sugestão, Elogio ou Denúncia? Exerça agora mesmo os seus direitos da Lei 13.460/2017."
                  inicial
                />
              )}
              {/* {dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppSic === 'S' && ( */}
              {dadosCidadeLoading && dadosCidadeLoading.OcultarAppSic === 'S' && dadosCidadeLoading.CorBotaoSic && (
                <GridBotao
                  to="/sic"
                  onClick={() => { dispatch(desfazerSecretaria()); limpaLoginAnonimo(dadosLogin); }}
                  key="Sic"
                  label="Pedido de Informação (e-SIC)"
                  img={`https://eouve.com.br/svg_icons/${isCorClara(dadosCidadeLoading.CorBotaoSic) ? 'dark' : 'light'}/sic.svg`}
                  size={17}
                  sizeDescricao={14}
                  imgWidth={55}
                  imgHeight={55}
                  cor={dadosCidadeLoading.CorBotaoSic}
                  className="controle-secretaria"
                  descricao="Precisa ter acesso à uma determinação Informação? Exerça agora mesmo os seus direitos da Lei 12.527/2011."
                  inicial
                />
              )}
              {/* {dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppZeladoria === 'S' && ( */}
              {dadosCidadeLoading && dadosCidadeLoading.OcultarAppZeladoria === 'S' && dadosCidadeLoading.CorBotaoZeladoria && (
                <GridBotao
                  to="/zeladoria"
                  onClick={() => { dispatch(desfazerSecretaria()); limpaLoginAnonimo(dadosLogin); }}
                  key="Zeladoria"
                  label="Zeladoria"
                  img={`https://eouve.com.br/svg_icons/${isCorClara(dadosCidadeLoading.CorBotaoZeladoria) ? 'dark' : 'light'}/zeladoria-limpeza-arrumado.svg`}
                  size={17}
                  sizeDescricao={14}
                  imgWidth={55}
                  imgHeight={55}
                  cor={dadosCidadeLoading.CorBotaoZeladoria}
                  className="controle-secretaria"
                  descricao="Gostaria de melhorar a sua cidade? Viu uma lâmpada queimada? Um buraco na rua? Um mato para cortar? Nos informe agora mesmo."
                  inicial
                />
              )}
            </GridInicial>
          </Container>
        </AppBody>
      </AppFragment>
    );
  }

  const busca = listaEstados && listaEstados.reduce((acc, { Cidades }) => [...acc, ...Cidades], []);

  const listaCidadesExcluidas = listaCidades && listaCidades.filter(({ Campo }) => Campo !== 'Campina do Monte Alegre');
  const listaCidadesExcluidasBusca = busca && busca.filter(({ Campo }) => Campo !== 'Campina do Monte Alegre');

  const filtro = listaCidadesExcluidasBusca.filter(({ Campo }) => {
    const campoFormatado = replaceDiacritico(Campo).toLowerCase();
    const buscaFormatado = replaceDiacritico(values.BuscaCidade).toLowerCase();
    return campoFormatado.includes(buscaFormatado);
  });

  return (
    <AppFragment
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          dispatch(resetarModais());
        }
      }}
      tabIndex="0"
    >
      <AppHeader />
      <AppBody className="controle-fundo" desfoque={dadosModal.desfoque}>
        <Container totem={getTotem() === 'true'}>
          <Linha>
            <span style={{ marginRight: espacamento.pequeno }}>Procurar cidade</span>
            <CampoForm
              totem={getTotem() === 'true'}
              value={texto}
              onChange={({ target }) => setTexto(target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  setValues({
                    ...values,
                    BuscaCidade: texto,
                  });
                }
              }}
            />
            <Botao
              cep
              totem={getTotem() === 'true'}
              onClick={() => setValues({
                ...values,
                BuscaCidade: texto,
              })}
            />
          </Linha>

          <Divisor border size="pequeno" />

          {values.BuscaCidade
            ? (
              <>
                {filtro.length
                  ? (
                    <Grid totem={getTotem() === 'true'}>
                      {filtro.map(({
                        Campo, Brasao, Id, IdeCrie, IdeSipe,
                      }) => (
                        <GridBotao
                          onClick={() => { escolherCidade(Id, IdeCrie, IdeSipe, Campo, Brasao); setTexto(''); }}
                          key={Id}
                          img={`https://eouve.com.br/Sistema/Arquitetura/Logos/${Brasao}`}
                          label={Campo}
                          totem={getTotem() === 'true'}
                        />
                      ))}
                    </Grid>
                  )
                  : (
                    <p>
                      <Alerta>
                        Nenhuma Cidade com a palavra
                        {' '}
                        <span style={{ fontWeight: 'bold' }}>{values.BuscaCidade}</span>
                        {' '}
                        foi encontrada.
                      </Alerta>
                    </p>
                  )}
              </>
            )
            : (
              <>
                {estadoSelecionado === true && (
                  <Linha>
                    <Botao
                      link
                      label="Voltar"
                      style={{ marginRight: espacamento.pequeno }}
                      onClick={() => setEstadoSelecionado(false)}
                    />
                    <p>
                      Estado:
                      {' '}
                      <b>{values.NomeEstado}</b>
                    </p>
                  </Linha>
                )}
                <Grid totem={getTotem() === 'true'}>
                  {estadoSelecionado === false
                    ? (listaEstados.map(({ Campo, Logo, Id: IdEstado }) => (
                      <GridBotao
                        totem={getTotem() === 'true'}
                        key={IdEstado}
                        img={`https://eouve.com.br/svg_icons/estados/${Logo}`}
                        label={Campo}
                        onClick={() => {
                          const estado = listaEstados.find(({ Id }) => Id === IdEstado);
                          const cidades = estado.Cidades;
                          setListaCidades(cidades);
                          setEstadoSelecionado(true);
                          setValues({
                            ...values,
                            IdEstado,
                            NomeEstado: Campo,
                          });
                          setTexto('');
                        }}
                      />
                    )))
                    : (listaCidadesExcluidas.map(({
                      Campo, Brasao, Id, IdeCrie, IdeSipe,
                    }) => (
                      <GridBotao
                        totem={getTotem() === 'true'}
                        key={Id}
                        onClick={() => escolherCidade(Id, IdeCrie, IdeSipe, Campo, Brasao)}
                        img={`https://eouve.com.br/Sistema/Arquitetura/Logos/${Brasao}`}
                        label={Campo}
                      />
                    )))}

                  {/* Botão da Cidade Webnets setado de forma Hardcode. Sempre que subir pra produção, comentar o botão abaixo */}
                  {/* <GridBotao
                    totem={getTotem() === 'true'}
                    key={1257}
                    onClick={() => escolherCidade(1257, 124, 2, 'Webnets', 'webnets-brasao.jpg')}
                    img="https://eouve.com.br/Sistema/Arquitetura/Logos/webnets-brasao.jpg"
                    label="Webnets"
                  /> */}
                </Grid>
              </>
            )}
        </Container>
      </AppBody>
    </AppFragment>
  );
};

export default SelecionarCidade;
